module.exports = __webpack_public_path__ + "static/media/showmax-Icon.7a506c14.png";